import React from "react";
import { observer } from "mobx-react";
import { SnapshotOverrideCreateStore } from "../../store";
import { SnapshotOverrideCreateForm } from "./SnapshotOverrideCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type SnapshotOverrideCreateProps = {
  snapshotOverrideCreateStore: SnapshotOverrideCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const SnapshotOverrideCreate: React.FC<SnapshotOverrideCreateProps> =
  observer(
    ({ snapshotOverrideCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={snapshotOverrideCreateStore.isSaving} />
          <SnapshotOverrideCreateForm
            snapshotOverrideCreateStore={snapshotOverrideCreateStore}
            relatedEntityTypeError={
              snapshotOverrideCreateStore.errors.relatedEntityType?.message
            }
            onRelatedEntityTypeChange={(value: string) => {
              snapshotOverrideCreateStore.setRelatedEntityTypeValue(value);
            }}
            relatedEntityType={
              snapshotOverrideCreateStore.entityValues.relatedEntityType
            }
            relatedEntityIdError={
              snapshotOverrideCreateStore.errors.relatedEntityId?.message
            }
            onRelatedEntityIdChange={(value: string) => {
              snapshotOverrideCreateStore.setRelatedEntityIdValue(value);
            }}
            relatedEntityId={
              snapshotOverrideCreateStore.entityValues.relatedEntityId
            }
            pathError={snapshotOverrideCreateStore.errors.path?.message}
            onPathChange={(value: string) => {
              snapshotOverrideCreateStore.setPathValue(value);
            }}
            path={snapshotOverrideCreateStore.entityValues.path}
            valueError={snapshotOverrideCreateStore.errors.value?.message}
            onValueChange={(value: string) => {
              snapshotOverrideCreateStore.setValueValue(value);
            }}
            value={snapshotOverrideCreateStore.entityValues.value}
            noteError={snapshotOverrideCreateStore.errors.note?.message}
            onNoteChange={(value: string) => {
              snapshotOverrideCreateStore.setNoteValue(value);
            }}
            note={snapshotOverrideCreateStore.entityValues.note}
            activeError={snapshotOverrideCreateStore.errors.active?.message}
            onActiveChange={(value: boolean) => {
              snapshotOverrideCreateStore.setActiveValue(value);
            }}
            active={snapshotOverrideCreateStore.entityValues.active}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={snapshotOverrideCreateStore.isProcessing}
            onSave={() => snapshotOverrideCreateStore.saveNewSnapshotOverride()}
            onCancel={() =>
              snapshotOverrideCreateStore.cancelNewSnapshotOverride()
            }
          />
          <ErrorDialog
            open={snapshotOverrideCreateStore.errorDialogOpened}
            title={snapshotOverrideCreateStore.errorTitle}
            description={snapshotOverrideCreateStore.errorDescription}
            onClose={() => snapshotOverrideCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
